import { useEffect } from 'react'

import { useSelector } from '@tabeeb/store'
import { getSessionTitle } from '@tabeeb/modules/appConfigState/selectors'

import { sessionTitleFormatter } from './SessionTitleFormatter'

const useSessionTitleFormatter = () => {
  const title = useSelector(getSessionTitle)

  useEffect(() => {
    sessionTitleFormatter.setTitle(title)
  }, [title])

  return {
    f: sessionTitleFormatter.format.bind(sessionTitleFormatter),
  }
}

export default useSessionTitleFormatter
